import { createContext } from "react";

export const EnvironmentContext = createContext({});
